import React, { useState } from "react";
import "./Offices.module.css";
import CustomLink from "../../components/CustomLink";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import spb from './img/spb.png';
import msk from './img/msk.png';
import perm from './img/perm.png';
import saratov from './img/saratov.png';

SwiperCore.use(Navigation);

function Offices(props) {
    // ДОБАВЛЕНО: Состояния для модального окна
    const [modalOpen, setModalOpen] = useState(false);
    const [modalImg, setModalImg] = useState(null);

    const items = [
        {
            "text": "комфортные офисы в санкт-петербурге",
            "url": spb,
            "id": 1
        },
        {
            "text": "комфортные офисы в Москве",
            "url": msk,
            "id": 2
        },
        {
            "text": "комфортные офисы в Перми",
            "url": perm,
            "id": 3
        },
        {
            "text": "комфортные офисы в Саратове",
            "url": saratov,
            "id": 4
        }
    ]

    // ДОБАВЛЕНО: Обработчик клика по картинке
    const handleImgClick = (imgUrl) => {
        setModalImg(imgUrl);
        setModalOpen(true);
    };

    // ДОБАВЛЕНО: Закрытие модального окна
    const closeModal = () => {
        setModalOpen(false);
        setModalImg(null);
    };

    return (
        <div className="Offices">
            <div className="OfficesVacancies">
                <CustomLink content="Смотреть вакансии" to="/vacancies" />
            </div>
            <h2>комфортные офисы</h2>
            <div className="PopularVacancies">
                <div className="PopularVacancies-button-prev"></div>
                <div className="PopularVacancies-button-next"></div>
                <div className="PopularVacancies-left-overlay"></div>
                <div className="PopularVacancies-right-overlay"></div>
                <Swiper
                    slidesPerView={2}
                    navigation={{
                        prevEl: ".PopularVacancies-button-prev",
                        nextEl: ".PopularVacancies-button-next",
                    }}
                    breakpoints={{
                        320: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                >
                    {items.map((el, i) => {
                        return (
                            <SwiperSlide key={el.id}>
                                <div className="PopularVacancies-slide">
                                    <div className="PopularVacancies-slide__top">
                                        <img
                                            className="PopularVacancies-slide__logo"
                                            src={el.url}
                                            alt={el.text}
                                            onClick={() => handleImgClick(el.url)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            {/* ДОБАВЛЕНО: Модальное окно для увеличенного изображения */}
            {modalOpen && (
                <div className="OfficesModal" onClick={closeModal}>
                    <div className="OfficesModal__content" onClick={e => e.stopPropagation()}>
                        <img src={modalImg} alt="office" />
                        <button
                            className="OfficesModal__close"
                            onClick={closeModal}
                            aria-label="Закрыть"
                        >×</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Offices;


// WEBPACK FOOTER //
// ./src/components/Offices/index.js